module.exports = function() {
  return new Worker(__webpack_public_path__ + "17f82fc0688baefbd9f9.worker.js");
};